/*
  History Timeline JS

  Functions:
  - Scroll reveal animation
  - Shopify OS2.0 compatible

*/


(function(){

  'use strict';


  function initHistoryTimeline(){


    const timelines = document.querySelectorAll(
      '.history-timeline-section'
    );


    if(!timelines.length){
      return;
    }



    timelines.forEach(function(section){


      const items = section.querySelectorAll(
        '.history-timeline-item'
      );


      if(!items.length){
        return;
      }




      /*
        Intersection Observer

        画面内に入った要素だけ
        アニメーション表示
      */


      const observer = new IntersectionObserver(

        function(entries){


          entries.forEach(function(entry){


            if(entry.isIntersecting){


              entry.target.classList.add(
                'is-visible'
              );


              /*
                一度表示したら監視解除
              */

              observer.unobserve(
                entry.target
              );


            }


          });


        },

        {

          threshold:0.15,

          rootMargin:
          "0px 0px -80px 0px"

        }


      );





      items.forEach(function(item,index){


        /*
          少しずつ表示タイミングをずらす
        */


        item.style.transitionDelay =
          (index * 0.08) + "s";



        observer.observe(item);



      });



    });


  }





  /*
    Shopify Theme Editor対応

    編集画面でセクションを
    追加・更新した場合も再初期化
  */


  document.addEventListener(
    'DOMContentLoaded',
    initHistoryTimeline
  );



  document.addEventListener(
    'shopify:section:load',
    initHistoryTimeline
  );



})();